import { useCallback } from 'react';
import { nameTableColumn } from '../constants/nameTableRso';
import { useSelector } from 'react-redux';

const useSelectedValuesColumn = (form) => {
  const { getFieldsValue, getFieldValue, setFieldsValue } = form;

  const valuesForm = getFieldsValue();

  const cleanedValues = Object.fromEntries(
    Object.entries(valuesForm).filter(([_, value]) => value !== undefined)
  );

  const { columnLabels } = useSelector((state) => state.rsoImportStore);

  const addressStartValue = getFieldValue(nameTableColumn.columnsAddressStart);

  const onClearValuesAddressEnd = (valueEnd) => {
    const startIndex = columnLabels.findIndex(
      (elem) => elem.value === addressStartValue
    );
    const endIndex = columnLabels.findIndex((elem) => elem.value === valueEnd);

    let columnLabelsUpdate = [...columnLabels];

    if (startIndex !== -1 && endIndex !== -1) {
      columnLabelsUpdate = columnLabelsUpdate.slice(startIndex + 1, endIndex);
    }

    Object.entries(cleanedValues).forEach(([key, val]) => {
      for (const leftItem of columnLabelsUpdate) {
        if (leftItem.value === val) {
          setFieldsValue({ [key]: '' });
          break;
        }
      }
    });
  };

  const getOptionsColumnForSelect = useCallback(
    (field) => {
      const selected = Object.entries(cleanedValues)
        .filter(([key]) => key !== field)
        .flatMap(([_, val]) => (Array.isArray(val) ? val : [val]));

      let columnLabelsUpdate = columnLabels;

      if (field === nameTableColumn.columnsAddressEnd) {
        const indexStart = columnLabels.findIndex(
          (elem) =>
            elem.value === cleanedValues[nameTableColumn.columnsAddressStart]
        );
        columnLabelsUpdate = columnLabelsUpdate.slice(indexStart);
      }

      if (
        cleanedValues[nameTableColumn.columnsAddressStart] &&
        cleanedValues[nameTableColumn.columnsAddressEnd] &&
        field !== nameTableColumn.columnsAddressEnd &&
        field !== nameTableColumn.columnsAddressStart
      ) {
        const startIndex = columnLabels.findIndex(
          (elem) =>
            elem.value === cleanedValues[nameTableColumn.columnsAddressStart]
        );
        const endIndex = columnLabels.findIndex(
          (elem) =>
            elem.value === cleanedValues[nameTableColumn.columnsAddressEnd]
        );

        if (startIndex !== -1 && endIndex !== -1) {
          const from = Math.min(startIndex, endIndex);
          const to = Math.max(startIndex, endIndex);

          columnLabelsUpdate = columnLabelsUpdate.filter(
            (_, index) => index < from || index > to
          );
        }
      }

      return columnLabelsUpdate.filter((opt) => !selected.includes(opt.value));
    },
    [columnLabels, cleanedValues]
  );

  return {
    getOptionsColumnForSelect,
    onClearValuesAddressEnd,
  };
};

export default useSelectedValuesColumn;
